<template>
  <div class="checkin">
    <div class="checkin-header clearfix">
      <h1 class="pull-left"><i class="el-icon-date"></i> Asistencia </h1>
      <el-dropdown class="pull-right"
                   v-if="canAdd()"
                   @command="handleCommand">
        <el-button :disabled="checkinReport.status === 'Aprobado' || checkinReport.status === 'Pendiente'" type="primary" size="small">
          Agregar <i class="el-icon-caret-bottom"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="1">Presente</el-dropdown-item>
          <el-dropdown-item :command="2">Ausente</el-dropdown-item>
          <el-dropdown-item :command="3">Tarde</el-dropdown-item>
          <el-dropdown-item :command="4">Maternidad</el-dropdown-item>
          <el-dropdown-item :command="5">Incapacidad INS</el-dropdown-item>
          <el-dropdown-item :command="6">Incapacidad CCSS</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-badge :hidden="checkinReport.hidden" :type="checkinReport.type" :value="checkinReport.status" class="pull-right"
                v-bind:style = "{'margin-right': checkinReport.margin}">
        <el-button @click="showDates()" type="primary" size="small">
          Confirmar Asistencia
        </el-button>
      </el-badge>
    </div>
    <div class="week-calendar">
      <nav>
        <button class="btn" @click="previousWeek()">
          <i class="el-icon-caret-left"></i>
        </button>
        <button class="btn" @click="currentWeek()">
          <i class="fa fa-dot-circle-o"></i>
        </button>
        <button class="btn" @click="nextWeek()">
          <i class="el-icon-caret-right"></i>
        </button>
        <h4>{{ current_week }}</h4>
        <select  v-model="cost_center_id" @change="onChangeCostCenters()" class="pull-right">
          <option
            v-for="item in cost_centers"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </option>
        </select>
      </nav>
      <div class="week" v-loading="loading">
        <div>
          <week-day v-for="item in week"
                    :key="item.id"
                    :date="item.day"
                    :is_disable="isDisable"
                    :cost_center_id="cost_center_id"
                    :employee_list="item.employees"
          ></week-day>
        </div>
      </div>
    </div>


    <el-dialog
      :title="Confirmation"
      width="30%"
      :visible.sync="dialogRecordsVisible">
      <el-form ref="formRecords" :model="formRecords" :rules="confirmRules" label-position="top">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Seleccione el rango de fecha que desea confirmar" prop="dates">
              <el-select v-model="formRecords.dates"
                         :placeholder="loadingReports ? 'Cargando...' : 'Seleccionar Periodo'"
                         style="width: 100%">
                <el-option
                  v-for="item in payrollDates"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
            <el-col :span="24"
                    v-show="checkinReport && checkinReport.report.observations && checkinReport.report.observations.length > 0">
              <p><strong>Observación General:</strong></p>
              <p v-for="item in checkinReport.report.observations">
                {{item.observation}}
              </p>
            </el-col>
            <el-col :span="24"
                    v-show="checkinReport && checkinReport.report.employee_observations && checkinReport.report.employee_observations.length > 0">
              <h4>Observaciones por Colaborador</h4>
            </el-col>
            <el-col :span="24"
                    v-show="checkinReport && checkinReport.report.employee_observations && checkinReport.report.employee_observations.length > 0"
                    >
              <el-card class="employee-observation"
                 shadow="hover"
                 v-for="observation in checkinReport.report.employee_observations"
                 :key="observation.id"
                >
                <div slot="header">
                  <span>{{ observation.employee.names }} {{ observation.employee.last_names }}</span>
                </div>
                <div class="text item ">
                  <el-row>
                    <el-col :sm="24" class="text-info">
                      {{ observation.observation}}
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" class="mt-2">
                    <el-col :sm="12">
                      {{ observation.created_at}}
                    </el-col>
                    <el-col :sm="12" class="text-right">
                      {{ observation.user.name }}
                    </el-col>
                  </el-row>
                </div>
              </el-card>
            </el-col>
        </el-row>
      </el-form>
      <el-alert
        v-if="success"
        title="Se ha confirmado exitosamente."
        type="success">
      </el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRecordsVisible = false">Cancelar</el-button>
        <el-button  type="primary"
                   :loading="processing"
                   @click="confirmCheckin()">
          <span v-if="processing">Procesando...</span>
          <span v-else>Confirmar</span>
        </el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="dialogTitle"
      width="30%"
      :visible.sync="dialogVisible">
      <el-form ref="form" :model="form" :rules="rules" label-position="top">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="Rango de Fecha" prop="range">
              <el-date-picker
                :disabled="processing"
                v-model="form.range"
                type="daterange"
                align="right"
                @change="onChangeDate()"
                unlink-panels
                range-separator="a"
                start-placeholder="Fecha de Inicio"
                end-placeholder="Fecha Final">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.checkin_status_id === 6 && form.range">
            <el-form-item label="Incapacidad pagada" prop="payed">
              <el-switch
                v-model="form.payed"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="Pagada"
                inactive-text="No Pagada">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.range">
            <el-form-item label="Empleados Incluidos" prop="include">
              <el-select
                style="width: 100%"
                v-model="form.include"
                multiple
                filterable
                :placeholder="(processing) ? 'cargando...':'Seleccionar el Empleado'">
                <el-option
                  v-for="item in employees"
                  :key="item.id"
                  :label="item.last_names + ' ' + item.names"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="form.range">
            <el-form-item label="Empleados Excluidos" prop="exclude">
              <el-select
                style="width: 100%"
                v-model="form.exclude"
                multiple
                filterable
                :placeholder="(processing) ? 'cargando...':'Seleccionar el Empleado'">
                <el-option
                  v-for="item in employees"
                  :key="item.id"
                  :label="item.last_names + ' ' + item.names"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div role="alert" v-if="error.message" class="el-alert el-alert--error">
        <div class="el-alert__content">
          <span class="el-alert__title is-bold">{{ error.message }}</span>
          <p class="el-alert__description">
            <ul>
              <li v-for="item in error.errors">{{ item[0] }}</li>
            </ul>
          </p>
        </div>
      </div>
      <el-alert
        v-if="success"
        title="Se ha guardado exitosamente."
        type="success">
      </el-alert>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancelar</el-button>
        <el-button type="primary"
                   :loading="processing"
                   @click="save()">
          <span v-if="processing">Procesando...</span>
          <span v-else>Guardar</span>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import Day from './Day'
  import Permissions from '../../components/abstract/Permissions'
  import * as moment from 'moment'
  import {baseApi} from '../../configs/urls'
  import {params, parseError} from '../../packages/Helpers'
  const uuidv4 = require('uuid/v4')
  moment.locale('es')
  export default {
    name: 'app-checkin-view',
    extends: Permissions,
    components: {
      'week-day': Day
    },
    data () {
      return {
        init_date: moment().day(0),
        end_date: moment().day(6),
        week: [],
        isDisable: false,
        cost_centers: [],
        cost_center_id: 0,
        loadingCostCenters: false,
        loading: false,
        processing: false,
        dialogTitle: 'Agregando',
        Confirmation: 'Confirmar Asistencia',
        dialogVisible: false,
        dialogRecordsVisible: false,
        loadingReports: false,
        payrollDates: [],
        observations: false,
        checkinReport: {
          status: '',
          type: 'warning',
          hidden: true,
          margin: '20px',
          report: {
            observations: [],
            employee_observations: []
          }
        },
        employees: [],
        filters: {},
        formRecords: {},
        form: {},
        rules: {
          range: [
            { required: true, message: 'El rango de fecha es requerido', trigger: 'blur' }
          ]
        },
        confirmRules: {
          dates: [
            { required: true, message: 'El rango de fecha es requerido', trigger: 'blur' }
          ]
        },
        error: {},
        success: false,
        basePermission: 'checkin'
      }
    },
    computed: {
      current_week: function () {
        return this.init_date.format('DD') + ' - ' + this.end_date.format('DD MMMM YYYY')
      }
    },
    methods: {
      refreshWeek () {
        const format = 'YYYY-MM-DD'
        const query = {
          init_date: this.init_date.format(format),
          end_date: this.end_date.format(format),
          cost_center_id: (this.cost_center_id) ? this.cost_center_id : 0
        }
        this.loading = true
        this.$http.get(baseApi + '/checkins/employees-by-range' + params(query))
          .then(
            (response) => {
              this.loading = false
              this.week = []
              const day = this.init_date.clone()
              while (day.isSameOrBefore(this.end_date)) {
                let employees = []
                if (response.data && response.data[day.format(format)]) {
                  employees = response.data[day.format(format)].map((item) => {
                    item.uuid = uuidv4()
                    return item
                  })
                }

                this.week.push({
                  id: uuidv4(),
                  day: day.clone(),
                  employees: employees
                })
                day.add(1, 'days')
              }
            },
            (res) => {
              this.loading = false
              this.$message.error(parseError(res)[0])
            }
          )
        this.getCheckinStatus()
      },
      previousWeek () {
        this.end_date = this.init_date.clone().day(-1)
        this.init_date = this.end_date.clone().day(0)
        this.refreshWeek()
      },
      currentWeek () {
        this.init_date = moment().day(0)
        this.end_date = moment().day(6)
        this.refreshWeek()
      },
      nextWeek () {
        this.init_date = this.init_date.clone().day(7)
        this.end_date = this.init_date.clone().day(6)
        this.refreshWeek()
      },
      handleCommand (status) {
        switch (status) {
          case 1:
            this.dialogTitle = 'Agregando Presente'
            break
          case 2:
            this.dialogTitle = 'Agregando Ausente'
            break
          case 3:
            this.dialogTitle = 'Agregando Tarde'
            break
          case 4:
            this.dialogTitle = 'Agregando Maternidad'
            break
          case 5:
            this.dialogTitle = 'Agregando Incapacidad INS'
            break
          case 6:
            this.dialogTitle = 'Agregando Incapacidad CCSS'
            break
        }

        this.form.checkin_status_id = status
        this.dialogVisible = true
      },
      onChangeDate () {
        const data = {
          init_date: moment(this.form.range[0]).format('YYYY-MM-DD'),
          end_date: moment(this.form.range[1]).format('YYYY-MM-DD'),
          cost_center_id: this.cost_center_id
        }
        this.$http.get(baseApi + '/checkins/employees-contract' + params(data)).then(
          (response) => {
            this.employees = response.data
          },
          (res) => {
            this.$message.error(parseError(res)[0])
          }
        )
      },
      onBlurSelectEmployee () {
        if (this.employee && this.form.employee !== this.employee.value) {
          this.form.employee_id = undefined
        }
      },
      showDates () {
        this.dialogRecordsVisible = true
        this.payrollDates = []
        this.loadingReports = true
        const data = {
          cost_center_id: this.cost_center_id
        }
        this.$http.get(baseApi + '/reports' + params(data))
          .then(
            (response) => {
              this.payrollDates = response.body
              this.loadingReports = false
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.loadingReports = false
            }
          )
      },
      confirmCheckin () {
        this.$refs['formRecords'].validate((valid) => {
          if (valid) {
            let result = this.payrollDates.filter((item) => {
              return item.value === this.formRecords.dates
            })
            this.processing = true
            const data = {
              init_date: result[0].init_date,
              end_date: result[0].end_date,
              cost_center_id: this.cost_center_id
            }
            this.$http.post(baseApi + '/checkins/checkins-report', data).then(
              () => {
                this.processing = false
                this.dialogRecordsVisible = false
                this.formRecords = {}
                this.$message.success('Se ha confirmado la asistencia.')
                this.getCheckinStatus()
                this.refreshWeek()
              },
              (res) => {
                this.processing = false
                this.$message.error(parseError(res)[0])
              }
            )
          }
        })
      },
      getCheckinStatus () {
        const format = 'YYYY-MM-DD'
        const data = {
          init_date: this.init_date.format(format),
          end_date: this.end_date.format(format),
          cost_center_id: this.cost_center_id
        }
        this.$http.get(baseApi + '/checkins-report-status' + params(data))
          .then(
            (response) => {
              const checkinReportData = {
                report: response.body,
                hidden: !response.body,
                status: '',
                type: 'warning',
                margin: '20px'
              }
              if (response.body) {
                if (checkinReportData.report.status === 'Aprobado') {
                  checkinReportData.status = 'Aprobado'
                  checkinReportData.type = 'success'
                  checkinReportData.margin = '60px'
                  this.isDisable = true
                } else if (checkinReportData.report.status === 'Pendiente') {
                  checkinReportData.status = 'Pendiente'
                  checkinReportData.type = 'warning'
                  checkinReportData.margin = '60px'
                  this.isDisable = true
                } else {
                  checkinReportData.status = checkinReportData.report.observations.length +
                    checkinReportData.report.employee_observations.length
                  checkinReportData.type = 'danger'
                  checkinReportData.margin = '20px'
                  this.isDisable = false
                }
              }
              this.checkinReport = checkinReportData
            },
            (res) => {
              this.$message.error(parseError(res)[0])
              this.loadingReports = false
            }
          )
      },
      save () {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.processing = true
            const data = {
              init_date: moment(this.form.range[0]).format('YYYY-MM-DD'),
              end_date: moment(this.form.range[1]).format('YYYY-MM-DD'),
              cost_center_id: this.cost_center_id,
              include: this.form.include,
              exclude: this.form.exclude,
              payed: this.form.payed,
              checkin_status_id: this.form.checkin_status_id
            }
            this.$http.post(baseApi + '/checkins/register-massively', data).then(
              () => {
                this.processing = false
                this.dialogVisible = false
                this.form = {}
                this.$message.success('Se ha registrado exitosamente la informacion del empleado.')
                this.refreshWeek()
              },
              (res) => {
                this.processing = false
                this.$message.error(parseError(res)[0])
              }
            )
          }
        })
      },
      onChangeCostCenters () {
        this.employees = []
        delete this.form.range
        this.refreshWeek()
      }
    },
    mounted () {
      this.refreshWeek()

      this.loadingCostCenters = true
      this.$http.get(baseApi + '/cost-centers').then(
        (response) => {
          this.loadingCostCenters = false
          this.cost_centers = response.data
          if (this.cost_centers.length > 0) {
            this.cost_center_id = this.cost_centers[0].id
            this.refreshWeek()
          }
        },
        (res) => {
          this.loadingCostCenters = false
          this.$message.error(parseError(res)[0])
        }
      )
    }
  }
</script>

<style lang="scss">
  .container {
    height: calc(100% - 172px);
    padding-bottom: 0 !important;
  }
  footer {
    display: none;
  }
  .employee-observation {
    width: 100%;
    .text-right {
      text-align: right;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/checkins/Index.vue